import { Row, Col, Image } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../../components/button/button.component';
import { routes } from '../../routes/main.routes';

interface FindCarBannerProps {
  style?: React.CSSProperties;
}

const FindCarBanner: React.FC<FindCarBannerProps> = function ({ style }) {
  const navigate = useNavigate();
  return (
    <Row style={style} gutter={[16, 16]}>
      <Col md={12} xs={24}>
        <StyledImagesSection>
          <CarBannerImage src="/jump-background.png" preview={false} />
        </StyledImagesSection>
      </Col>

      <Col md={12} xs={24}>
        <VerticalCenteredContainer>
          <StyledH2>
            Find the perfect car{' '}
            <span className="highlight">
              to
              <br />
              upgrade your vacation plan
            </span>
          </StyledH2>

          <Button type={'primary'} onClick={() => navigate(routes.vehicles.path)} id="tip-browse-car">
            Browse cars
          </Button>
        </VerticalCenteredContainer>
      </Col>
    </Row>
  );
};

export default FindCarBanner;

const VerticalCenteredContainer = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);

  @media only screen and (max-width: 768px) {
    && {
      position: relative;
    }
  }
`;

const StyledImagesSection = styled.div`
  position: relative;
  display: block;
  display: inline-block;
`;

const CarBannerImage = styled(Image)`
  width: 100%;
`;

const StyledH2 = styled.h2`
  text-align: left;
  margin-bottom: 40px;

  .highlight {
    color: var(--button-color-primary);
  }
`;
